
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const IshiharaPlates = (props) => {
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: false,
      };
        const { type } = props;
        let plates = [];
        console.log('type', type);

        switch (type) {
            case "Ishihara - 6 Plates":
                plates = [12, 5, 26, 6, 16, 0];
                break;
            case "Ishihara - 14 Plates":
                plates = [12, 8, 5, 29, 74, 7, 45, 2, "no number", 16, "trace a line", 35, 96, "trace both lines"];
                break;
            default:
                plates = [12, 8, 5, 29, 74, 7, 45, 2, "no number", 16, "trace a line", 35, 96, "trace both lines"];
                break;
        }

        console.log('Plates:', plates);


    let platesArr = [];
    let setAllDefaultValues = {};
    plates.map((plate, plateIndex) => {
        setAllDefaultValues = {
            ...setAllDefaultValues,
            ['plate_number_' + (plateIndex + 1) + '']: 1
        }
        platesArr = [
            ...platesArr,
            {
                label: `Plate No. ${plateIndex + 1}`,
                type: 'Label',
                isBold: false,
                fontBold: '100',
                col: 'col-2'
            },
            {
                label: <span style={{ color: 'green' }}>{plate}</span>,
                type: 'Label',
                fontBold: '100',
                col: 'col-2'
            },
            {
                label: 'Mark "Yes" if Correct, "No" if Incorrect',
                col: 'col-8',
                type: 'RadioGroup',
                name: 'plate_number_' + (plateIndex + 1) + '',
                id: 'plate_number_' + (plateIndex + 1) + '',
                options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
            },
            {
                type: 'Blank',
                col: 'col-4',
                rules: [{ rule: [{ field: 'plate_number_' + (plateIndex + 1) + '', value: 0, operator: '===' }], action: 'SHOW' }]
            },
            {
                label: 'Patient Answer (if not readable)',
                type: 'TextArea',
                col: 'col-8',
                rules: [{ rule: [{ field: 'plate_number_' + (plateIndex + 1) + '', value: 0, operator: '===' }], action: 'SHOW' }],
                id: 'plate_number_' + (plateIndex + 1) + '_patient_answer',
                name: 'plate_number_' + (plateIndex + 1) + '_patient_answer',

            }
        ]
    });

    const charts = [{
        type: 'Grid',
        col: 'col-md-3',
        data: [{
            type: "PatientDetails",
            employeeDetails: props.employeeDetails,
            visitDetails: props.visitDetails
        }, {
            type: "CompanyDetails",
            companyDetails: props.companyDetails
        }],
    }, {
        type: 'Tab',
        col: 'col-md-9',
        data: [
            {
                id: 'ishihara_details',
                label: 'Ishihara Details',
                data: [
            {
                label: 'Activity Details - ' + props.activityName,
                fields: [
                    {
                        label: 'Plate',
                        type: 'Label',
                        appendClass: 'bg-light',
                        col: 'col-2'
                    },
                    {
                        label: 'Answer',
                        type: 'Label',
                        appendClass: 'bg-light',
                        col: 'col-2'
                    },
                    {
                        type: 'Label',

                        label: <a onClick={() => props.updateFormData({ ...setAllDefaultValues, ...computationRules({ ...props.formData, ...setAllDefaultValues }, plates, 'plate_number_1') })} className="badge bg-blue-soft text-light cursor-pointer custom-btn" style={{ cursor: 'pointer' }}>
                            Set all to Yes
                        </a>,
                        appendClass: 'bg-light',
                        col: 'col-8',
                    },
                    ...platesArr
                ]
            },
            {
                label: 'Notes',
                fieldProps: stackedFieldStyle,
                fields: [
                    {
                        label: 'Notes',
                        col: 'col-12',
                        type: "NewTextArea",
                        label: "Notes",
                        placeholder: "Add Comments",
                        className: "form-control form-control-solid",
                        name: "notes",
                        col: "col-12 border-0",
                        name: 'notes',
                    },
                    // {
                    //     label: 'Suggested Result',
                    //     type: 'TextInput',
                    //     disabled: true,
                    //     options: isSet(props.lookupsOptions['chartResult'], []),
                    //     name: 'suggested_status',
                    // },
                    {
                        type: 'Blank',
                        name: 'blank'
                    },
                    // {
                    //     label: 'Final Determination',
                    //     type: 'SelectList',
                    //     options: isSet(props.lookupsOptions['chartResult'], []),
                    //     name: 'status',
                    // },


                ]
            },
            {
                label: 'Review / Completion',
                // labelStyle: 'fw-semibold',
                fields: [
                    {
                        type: 'ProviderSignOff',
                        col: 'col-12',
                        fields: [
                            { label: "Signature PIN", name: 'provider_pin', col: 'col-12' },
                            { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                            { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                            // { label : "Suggested Result", disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                            // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options:isSet(props.lookupsOptions['chartResult'],[]),statusBasedColor: true },
                            { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive']),statusBasedColor: true },
                            // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                            { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled']),statusBasedColor: true },
                        ],
                    },
                ],
            }
                ]
            },
            {
                id: 'Images',
                label: 'Images',
                data: []
            }
        ]
    }];
    const defaultValue = {
        status: 'Not Started',
        suggested_status: 'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Ishihara Details',
                id: 'ishihara_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return { charts, defaultValue, headers, computationFunction: (formData, key) => ({...computationRules(formData, plates, key,type), ...computationRules1(formData,key)}) };
}



const computationRules = (formData, plates, key,type) => {
    let status = 'Not Started';
    let activity_status = 'Not Started';
    let suggestedStatus = 'Not Started';
    let zeroCount = 0;
    let nullFound = false;
    let isComputationReadingsOnChnaged = false;
    plates.forEach((plate, plateIndex) => {
        const value = isSet(formData[`plate_number_${plateIndex + 1}`], null);
        if (key === `plate_number_${plateIndex + 1}`) {
            isComputationReadingsOnChnaged = true;
        }
        if (value === 0) {
            zeroCount++;
        } else if (value === null) {
            nullFound = true;
        }
    });
    let failedCount=type=="Ishihara - 6 Plates"?0:2;
    if (isComputationReadingsOnChnaged === false) { return false; }
    if (zeroCount > failedCount) {
        status = 'Failed';
        activity_status = 'Completed';
        suggestedStatus = 'Abnormal, Deficiency';
    } else if (nullFound) {
        status = 'Pending';
        activity_status = 'Pending';
        suggestedStatus = 'Pending';
    } else {
        status = 'Passed';
        activity_status = 'Completed';
        suggestedStatus = 'Normal, No Deficiency';
    }
    return (key === 'status') ? {} : { 'status': status, 'suggested_status': suggestedStatus, 'activity_status': activity_status };

}